import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { OpenGateSelectorPage } from './open-gate-selector.page';

const routes: Routes = [
  {
    path: '',
    component: OpenGateSelectorPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OpenGateSelectorPage]
})
export class OpenGateSelectorPageModule {}
